import React from "react";

import PostCard from "./PostCard";
import { useRouter } from "next/navigation";
import type { FormattedPost } from "@/lib/blog";

function Posts({ posts }: PostsProps) {
  const router = useRouter();
  const renderedPosts = posts.map((post, index) => (
    <PostCard key={post.id} post={post} isFirst={index === 0} router={router} />
  ));

  return <div className="row">{renderedPosts}</div>;
}

interface PostsProps {
  posts: FormattedPost[];
}

export default Posts;
